import { render, staticRenderFns } from "./SelectionStep.vue?vue&type=template&id=254c0dc3&scoped=true&"
import script from "./SelectionStep.vue?vue&type=script&lang=js&"
export * from "./SelectionStep.vue?vue&type=script&lang=js&"
import style0 from "./SelectionStep.vue?vue&type=style&index=0&id=254c0dc3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254c0dc3",
  null
  
)

export default component.exports